module.exports = __webpack_public_path__ + "img/1F604.842735e9.svg";